import { all } from 'redux-saga/effects';

import exportSaga from './export';
import importSaga from './import';
import importValidationSaga from './importValidation';

export function* saga() {
    yield all([exportSaga(), importSaga(), importValidationSaga()]);
}
